import {Phase} from "../../Server/DB/@Shared/Phase.js";
import React from "react";
import {CheckBox, Row} from "react-vcomponents";
import {GetValues} from "js-vextensions";

const phaseLabels: Record<string, string> = {
	[Phase.initialDelay]: "Init", // "Initial delay" is too long
	[Phase.tech]: "Tech",
	[Phase.drifting]: "Drifting",
	[Phase.dreaming]: "Dreaming",
	[Phase.solving]: "Solving",
	[Phase.delving]: "Delving",
};

const selectablePhases = GetValues(Phase).filter(p=>p != Phase.notStarted);

export const PhaseSelectionUI = (props: {value: Phase[], onChange: (val: Phase[])=>void, enabled?: boolean})=>{
	const {value, onChange, enabled} = props;
	return (
		<Row>
			{selectablePhases.map(phase=>(
				<CheckBox key={phase} ml={5} enabled={enabled} text={phaseLabels[phase]}
					value={value.includes(phase)}
					onChange={checked=>{
						const newArray = checked ? [...value, phase] : value.filter(p=>p != phase);
						const newArray_ordered = selectablePhases.filter(p=>newArray.includes(p));
						onChange(newArray_ordered);
					}}
				/>
			))}
		</Row>
	);
};